import Vue from 'vue';
import {getUserTa} from '@/api/user';
import {fetchInsightTas, fetchInsightProducts} from '@/api/kol';
import {getLocalStorage} from '@/utils/index';

// 用户治疗领域与 kvp_key 数据的进程内缓存。
// 登录/首次使用时一次性加载，后续页面直接复用，避免重复请求接口。
// 使用 Vue.observable 保证数据响应式，computed 依赖能正确触发更新。
const state = Vue.observable({
  loaded: false,
  loading: null,
  // 当前用户的治疗领域 ta_id 列表（来自 UserTas）
  userTas: [],
  // 治疗领域 kvp_key 数据（kvp_id = 'ta'）
  tas: [],
  // 产品或疾病 kvp_key 数据（kvp_id = 'product_or_disease'，已按用户领域过滤）
  productOrDisease: [],
});

// 加载用户治疗领域与 kvp 数据，重复调用会复用同一个 Promise
export function loadKvpCache(userId = getLocalStorage('user_id')) {
  if (state.loaded) return Promise.resolve(state);
  if (state.loading) return state.loading;

  state.loading = (async () => {
    let userTas = [];
    if (userId) {
      const userTasRes = await getUserTa({user_id: userId});
      userTas = (userTasRes?.value || []).map((item) => item.ta_id);
    }

    const [tas, productOrDisease] = await Promise.all([
      fetchInsightTas(),
      fetchInsightProducts(userTas),
    ]);

    state.userTas = userTas;
    state.tas = tas || [];
    state.productOrDisease = productOrDisease || [];
    state.loaded = true;
    state.loading = null;

    return state;
  })();

  return state.loading;
}

// 读取缓存的用户治疗领域 ta_id 列表
export function getCachedUserTas() {
  return state.userTas;
}

// 读取缓存的治疗领域数据
export function getCachedTas() {
  return state.tas;
}

// 读取缓存的产品或疾病数据
export function getCachedProducts() {
  return state.productOrDisease;
}

// 根据治疗领域名称查找对应的 ta 记录
export function findTaByName(taName) {
  return state.tas.find((item) => item.kvp_key_name === taName) || null;
}

// 根据治疗领域 id 查找对应的 ta 记录
export function findTaById(taId) {
  return state.tas.find((item) => item.kvp_key_id === taId) || null;
}

// 根据治疗领域名称过滤出对应的产品或疾病列表
export function filterProductsByTa(taName) {
  const ta = findTaByName(taName);
  if (!ta) return [];
  return state.productOrDisease.filter(
    (item) => item.parent_kvp_key_id === ta.kvp_key_id,
  );
}

// 根据治疗领域 id 过滤出对应的产品或疾病列表
export function filterProductsByTaId(taId) {
  return state.productOrDisease.filter(
    (item) => item.parent_kvp_key_id === taId,
  );
}

// 清空缓存（切换账号/角色时调用）
export function resetKvpCache() {
  state.loaded = false;
  state.loading = null;
  state.userTas = [];
  state.tas = [];
  state.productOrDisease = [];
}
